import { useEffect, useState, startTransition } from "react";
import { api } from "@/lib/api";

/** Seitenweit einmal geladene Kleinigkeiten (CMS-Seiten, Willkommens-Gutschein) – Header, Footer, Start und Exit-Popup teilen sich eine Anfrage. */
const mem = {};
const once = (key, url) => {
  if (!mem[key]) mem[key] = api.get(url).then((r) => r.data).catch(() => { delete mem[key]; return null; });
  return mem[key];
};

export const usePages = () => {
  const [pages, setPages] = useState([]);
  useEffect(() => { once("pages", "/pages").then((d) => startTransition(() => setPages(d || []))); }, []);
  return pages;
};

/** Themen der Reisetipps mit Anzahl (beliebteste zuerst) – Footer. */
export const useTipTopics = () => {
  const [topics, setTopics] = useState([]);
  useEffect(() => { once("tipTopics", "/pages/tips/topics").then((d) => startTransition(() => setTopics(d || []))); }, []);
  return topics;
};

export const useWelcomeVoucher = () => {
  const [v, setV] = useState(null);
  useEffect(() => { once("welcome", "/vouchers/welcome").then((d) => startTransition(() => setV(d?.code ? d : null))); }, []);
  return v;
};
